module.exports = __webpack_public_path__ + "./fonts/BasierCircle-Regular.ttf";